import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Formik, Form } from "formik";
import { Spinner, IconButton } from "components/common";
import {
  GranteeListItemTitle,
  GranteeInfo,
  StyledGranteeIcon,
  GranteeListItemContainer
} from "components/permissions/CommonStyledComponents";
import CapabilitySelect from "../CapabilitySelect";
const StyledCapabilitySelect = styled(CapabilitySelect)`
  flex: 0.5;
`;
const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  margin-left: 10px;
`;
const GranteesListItem = ({
  availableCapabilities,
  currentGranteeState,
  grantee: { id, capabilityId, type, title },
  onDelete,
  onCapabilityChange
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const handleDelete = () => {
    setIsDeleting(true);
    onDelete(id).then(() => setIsDeleting(false));
  };
  return /* @__PURE__ */ React.createElement(Formik, { initialValues: { capabilityId }, onSubmit: () => {
  } }, /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(GranteeListItemContainer, { $currentState: currentGranteeState }, /* @__PURE__ */ React.createElement(GranteeInfo, { title }, /* @__PURE__ */ React.createElement(StyledGranteeIcon, { type }), /* @__PURE__ */ React.createElement(GranteeListItemTitle, null, title)), /* @__PURE__ */ React.createElement(
    StyledCapabilitySelect,
    {
      onChange: (newCapabilityId) => onCapabilityChange({ granteeId: id, capabilityId: newCapabilityId }),
      capabilities: availableCapabilities,
      title: `Change the capability for ${title}`
    }
  ), /* @__PURE__ */ React.createElement(Actions, null, isDeleting ? /* @__PURE__ */ React.createElement(Spinner, { text: "" }) : /* @__PURE__ */ React.createElement(IconButton, { name: "delete", onClick: handleDelete, title: `Remove sharing for ${title}` })))));
};
export default GranteesListItem;
